import styled from '@emotion/styled'

const withStyle = (Component) =>
  styled(Component)((props) => {
    const { theme } = props
    return `
        background: ${theme.errorBoundaryBgColor};
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
        flex-grow: 1;

        i {
          color: ${theme.errorBoundaryIconColor};
        }

        .app-error {
          i {
            font-size: 37px;
            height: 37px;
            width: 37px;
            margin-bottom: 10px;
          }

          h1 {
            margin-bottom: 4px;
          }

          p {
            margin-bottom: 24px;
          }
        }

        .component-error {

          i {
            display: inline-block;
            font-size: 18px;
            position: relative;
            top: -5px;
          }

          h2 {
            display: inline;
            margin: 0 0 0 4px;
          }
        }
      `
  })

export default withStyle
